// index.js
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    UserForms: [],
    OrderForms:[],
    userInfo: null,
  },
  mutations: {
    updateUserForms(state, payload) {
      state.UserForms = payload;
    },
    updateOrderForms(state, payload) {
      state.OrderForms = payload;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo; // 确保有这个 mutation
    },   
  },
  actions: {
    async fetchUserInfo({ commit }, id) {
      try {
        const response = await axios.get(`UserForm/${id}`);
        commit('setUserInfo', response.data); // 触发 mutation
      } catch (error) {
        console.error("获取人员信息失败:", error);
      }
    },
    fetchOrderForms({ commit }) {
      // 模拟异步请求
      setTimeout(() => {
        const orderForms = [
          // 示例数据
        ];
        commit('updateOrderForms', orderForms);
      }, 1000);
    }
  },
  getters: {
    getOrderForms: state => state.orderForms
  }
});

export default store;